import { Injectable } from '@angular/core';
import * as SentryAngular from "@sentry/angular";
import { environment } from 'src/environments/environment';
import { StorageManagerService } from '../storage-manager.service';
import type { Client } from '@sentry/types';
import { FeedbackService, MsgType } from '../feedback.service';

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  
  private _sentryEnabled : boolean;
  public get sentryEnabled() : boolean {
    return this._sentryEnabled;
  }
  public set sentryEnabled(v : boolean) {
    this._sentryEnabled = v;
  }

  constructor(
    private storageManager: StorageManagerService,
    private feedback: FeedbackService
  ) { 
    
  }

  public async toggleSentryEnabled(value: boolean, firstSetup?: boolean){
    await this.storageManager.setItem<boolean>("SENTRY_ENABLED", value)
    if(!firstSetup) await this.feedback.showMsg(MsgType.Info, "Die Einstellungen wurden gespeichert. Beim nächsten Neststart wird die Änderung wirksam.")
  }

  /**
   * Lädt aus local Storage ob Sentry aktiviert wurde 
   * Wenn ja wird direkt Sentry initialisiert
   */
  public async loadSentryEnabled(): Promise<void>{
    this.sentryEnabled = await this.storageManager.getItem<boolean>("SENTRY_ENABLED", false)    
    await this.initSentry()
  }
  
  
  /**
   * Initialisiert Sentry um Fehler zu senden
  */
 public async initSentry(){
    if(!this.sentryEnabled) return
    SentryAngular.init({
      enabled: true,
      integrations: [
        SentryAngular.browserTracingIntegration(),
      ],
      dsn: environment.sentryUrl,
      environment: environment.production ? "production" : "development",
      release: `ticketsystem-web-client@${environment.version}`,
      beforeSend(event){

        //Verhindert dass fehler von node modules an sentry gesent werden
        if(event.exception && event.exception.values){
          const isNodeModuleError: boolean = event.exception.values.some(
            (exception) => exception.stacktrace?.frames?.some(
              (frame) => frame.filename?.includes("node_modules")
            )
          )
          if(isNodeModuleError) return null
        }
        return event
      }
    }
  );
  
  
  
  }

  public async test(){
    throw new Error("Ein Testfehler")
  }

}
